import { useMutation } from "@tanstack/react-query";

import { apiRoutes } from "~/shared/services/api/api-routes.ts";
import { postAndValidate } from "~/shared/services/api/fetch-client.ts";
import type { ApiResult } from "~/shared/types/api-types.ts";
import { getIsInternal } from "~/shared/utils/get-deployment-type.ts";

import type { QuoteReplacement } from "../schemas/quote-replacement-schema.ts";
import { quoteReplacementSchema } from "../schemas/quote-replacement-schema.ts";

/**
 * Requote v2: replaces a quote with a newly rated one. The API rejects quotes
 * in a Bulk Tender error state with a 400 describing why, so the caller only
 * needs to surface `result.error`.
 */
export const useRequoteQuote = () =>
	useMutation<ApiResult<QuoteReplacement>, Error, number>({
		mutationFn: async (quoteId) => {
			const route = getIsInternal()
				? apiRoutes.REQUOTEQUOTE
				: apiRoutes.EXTERNALREQUOTEQUOTE;

			return await postAndValidate(
				route.replace(":quoteId", String(quoteId)),
				{},
				quoteReplacementSchema,
			);
		},
	});
